/** Runtime configuration, provided by /config.js (generated per environment). */
export interface AppConfig {
  authMode: 'keycloak' | 'disabled'
  keycloakUrl: string
  keycloakRealm: string
  keycloakClientId: string
}

declare global {
  interface Window {
    __DMS_CONFIG__?: Partial<AppConfig>
  }
}

export const config: AppConfig = {
  authMode: 'keycloak',
  keycloakUrl: '',
  keycloakRealm: '',
  keycloakClientId: 'drittmittelscan-web',
  ...window.__DMS_CONFIG__,
}
